// Masonry layout for the product grid (Pinterest mode of the customize wand).
// Grid + row-span technique: the grid keeps its normal 2/3/4 responsive
// columns; each item spans ceil((cardHeight + gap) / 4px) rows, producing the
// staggered board. Chosen over CSS multicolumn, which WebKit/iOS cannot paint
// reliably (images in 2nd+ column fragments stay blank).
(function () {
  var grids = document.querySelectorAll('.collection-filter__grid');
  if (!grids.length) return;
  var ROW = 4; // must match grid-auto-rows in section-collection-filter.css

  var active = function () {
    return document.documentElement.getAttribute('data-kodama-grid') === 'masonry';
  };

  var layout = function () {
    // Re-query every pass: the sections catalog view (customize wand)
    // creates fresh .collection-filter__grid containers at runtime.
    document.querySelectorAll('.collection-filter__grid').forEach(function (grid) {
      var items = grid.querySelectorAll('.collection-filter__item');
      if (!active()) {
        items.forEach(function (item) {
          item.style.gridRowEnd = '';
        });
        return;
      }
      var gap = parseFloat(getComputedStyle(grid).columnGap) || 15;
      items.forEach(function (item) {
        if (item.classList.contains('is-hidden')) return;
        var card = item.firstElementChild;
        if (!card) return;
        var h = card.getBoundingClientRect().height;
        item.style.gridRowEnd = 'span ' + Math.max(1, Math.ceil((h + gap) / ROW));
      });
    });
  };

  var timer = null;
  var request = function () {
    clearTimeout(timer);
    timer = setTimeout(layout, 60);
  };

  window.addEventListener('resize', request);
  document.addEventListener('kodama:grid', request);
  document.addEventListener('kodama:view', request);
  document.addEventListener('kodama:sections', request);
  // Re-span as card images load (their info block height can shift) and when
  // the filter shows/hides items or the lazy-loader appends more.
  document.addEventListener(
    'load',
    function (event) {
      if (event.target.tagName === 'IMG' && event.target.closest('.collection-filter__grid')) request();
    },
    true
  );
  grids.forEach(function (grid) {
    new MutationObserver(request).observe(grid, { childList: true, subtree: true, attributeFilter: ['class'], attributes: true });
  });

  layout();
  // The first pass can run before the media boxes have resolved their
  // aspect-ratio height (and cached images fire no load events), so settle
  // with a couple of follow-up passes plus one after the full window load.
  window.addEventListener('load', request);
  setTimeout(layout, 400);
  setTimeout(layout, 1200);
})();
